import axiosInstance from '../../axiosInstance';

export interface LinkWorkItemsPayload {
  sourceWorkItemUuid: string;
  targetWorkItemUuid: string;
  linkType: string;
}

export interface LinkWorkItemsResponse {
  response: string;
  message?: string;
  status?: boolean;
}

export const linkWorkItems = async (
  payload: LinkWorkItemsPayload
): Promise<LinkWorkItemsResponse> => {
  const { data } = await axiosInstance.post<LinkWorkItemsResponse>('pmo/link-work-items', payload);
  return data;
};
